<template>
  <div>
    <page-header title="Resources"></page-header>
    <div class="page-content col-12" v-html="resource.content"></div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';
  import AppFooter from '@/component/AppFooter';
  import LernerHeader from '@/component/Header';
  import PageHeader from '@/component/PageHeader';
  import { FETCH_RESOURCE } from '@/store/actions/resource.actions';
  import { CHANGE_DOC_TITLE } from '@/store/actions/app.actions';

  export default {
    name: 'resources',

    data: () => {
      return {
        pending: false
      }
    },

    components: {
      PageHeader,
      LernerHeader,
      AppFooter
    },

    created: function () {
      this.$store.dispatch(CHANGE_DOC_TITLE, {title: 'Resources', useBaseTitle: true});
      this.$store.dispatch(FETCH_RESOURCE);
    },

    computed: {
      ...mapGetters([
        'pages',
        'resource'
      ])
    }
  };
</script>

<style lang="scss">
  .page-content {
    h2 {
      @apply font-primary font-bold text-primary mb-6 leading-none;
      font-size: 20px;
    }

    a {
      @apply text-lerner-blue;
    }

    p, ul {
      @apply mb-6;
    }
  }
</style>
